<script>
export default {
  name: 'App',
  data () {
    return {
      drawer: false,
      links: [
        { action: '#home', title: 'Home', icon: 'home' },
        { action: '#about', title: 'About', icon: 'home' },
        { action: '#services', title: 'Services', icon: 'home' },
        { action: '#contact', title: 'Contact', icon: 'home' }
      ]
    }
  },
  methods: {
    closeDrawer () {
      this.drawer = false
    }
  }
}
</script>

<template>
  <v-app id="lcrplus">
    <v-navigation-drawer class="hidden-md-and-up"
      fixed
      v-model="drawer"
      app
      temporary
      @click.stop="drawer = !drawer"
    >
    <scrollactive
      id="drawer-nav"
      v-on:itemchanged="closeDrawer"
      :offset="61"
      :duration="800"
      bezier-easing-value=".5,0,.35,1">
        <v-btn href="#home" color="grey lighten-5" class="scrollactive-item" @click="closeDrawer">Home</v-btn>
        <v-btn href="#about" color="grey lighten-5" class="scrollactive-item" @click="closeDrawer">Company</v-btn>
        <v-btn href="#services" color="grey lighten-5" class="scrollactive-item" @click.stop="drawer = !drawer">Services</v-btn>
        <v-btn href="#contact" color="grey lighten-5" class="scrollactive-item" @click="closeDrawer">Contact</v-btn>
      </scrollactive>

    </v-navigation-drawer>
    <v-toolbar color="white" dark app fixed>
      <v-toolbar-title>
        <scrollactive
          :offset="61"
          :duration="800"
          bezier-easing-value=".5,0,.35,1">
        <router-link :to="{ path: '#home' }" class="brand-logo scrollactive-item"></router-link>
         </scrollactive>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-side-icon color="grey darken-2" @click.stop="drawer = !drawer" class="hidden-md-and-up"></v-toolbar-side-icon>
      <v-toolbar-items class="hidden-sm-and-down">
         <scrollactive
          :offset="61"
          :duration="800"
          bezier-easing-value=".5,0,.35,1">
        <v-btn href="#home" color="grey lighten-5" class="scrollactive-item">Home</v-btn>
        <v-btn href="#about" color="grey lighten-5" class="scrollactive-item">Company</v-btn>
        <v-btn href="#services" color="grey lighten-5" class="scrollactive-item">Services</v-btn>
        <v-btn href="#contact" color="grey lighten-5" class="scrollactive-item">Contact</v-btn>
        </scrollactive>
      </v-toolbar-items>
    </v-toolbar>
    <v-content>
      <v-container fluid class="pa-0">
          <router-view></router-view>
      </v-container>
    </v-content>

    <footer>
      <v-container class="maxed">
        <v-layout row wrap>
          <v-flex xs12>
            <div>LCRPlus © {{ new Date().getFullYear() }}</div>
          </v-flex>
        </v-layout>
      </v-container>
    </footer>

  </v-app>
</template>

<style lang="scss">
  @import './assets/scss/app.scss'
</style>



// WEBPACK FOOTER //
// src/App.vue